import React, { useState, useEffect } from 'react';
import ReceivedSent from '../../components/faxes/received';
import Sent from '../../components/faxes/sent';
import { showToast } from '../../services/toastifyservices';
import { handleSession } from '../../api/apiSessionHandle'
import CommonSpinner from '../../services/commonSpinner';
import { getaxiosRequestWithToken, FetchFaxes, postaxiosRequestWithToken } from "../../api/api";
import { PaginationControls } from "../../components/pagination"
import { useNavigate } from 'react-router-dom';
import './faxes.css';

const Faxes = () => {
  const navigate = useNavigate();

  const [subTab, setSubTab] = useState('received');
  const [loading, setLoading] = useState(true);
  const [faxHistory, setfaxHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();
  useEffect(() => {
    fetchLocation();
  }, []);

  const fetchLocation = async (currentPage) => {
    
    try {
      setLoading(true);
      const response = await getaxiosRequestWithToken("assistant_api/fax-history");
      if (response.success) {
        var data = response.data.fax_response.data;
        // const filteredRows = data.data.filter(row => row.status === "Received");
        setCurrentPage(currentPage || data.current_page);
        setRowsPerPage(data.per_page);
        setTotalPages(Math.ceil(data.total / data.per_page))
        fetchFaxes(currentPage || Math.ceil(data.total / data.per_page),data.per_page)
        //setfaxHistory(data.data);

      }
    } catch (error) {
      showToast('error', error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      
      //setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetchFaxes(page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetchFaxes(currentPage, newLimit);
  };

  const fetchFaxes = async (page, limit = rowsPerPage) => {

    // if (pageCache.current[page]?.limit === limit) {
    //   const cachedData = pageCache.current[page];
    //   setProgramdata(cachedData.data);
    //   setCurrentPage(cachedData.current_page);
    //   setTotalPages(cachedData.last_page);
    //   setLoading(false);
    //   return;
    // }

    setLoading(true);
    try {
      const Payload = {
        // medical_program_id: selectedProgram,
        // provider_id: selectedProviders,
        // last_billing_date: SelectedLastBillingDate,
      };
      const response = await FetchFaxes(page);
      if (response) {
        var responseData = response.data.fax_response.data;
        const { data, current_page, last_page } = responseData;
        setfaxHistory(data);
        setCurrentPage(current_page);
        setTotalPages(last_page);
      }
    } catch (error) {
      handleSession(error.response?.data, navigate);
      showToast('error', error.response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  const updatefaxstatus = async (message_id) => {
    try {
      const payload = { message_ids: [message_id] };
      const response = await postaxiosRequestWithToken('assistant_api/update-fax-status', payload);

      if (response.success) {
        showToast('success', response.message);
        await fetchLocation(currentPage);
      }
    } catch (error) {
      console.error("Error updating fax status:", error); // Debugging log
      showToast('error', error.message || 'Failed to update fax status');
    }
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">Faxes</span>
      </div>
      <div className='card mt-2'>
        <div className='card-body '>
          {/* <button
            className={`py-2 px-6 rounded-lg hover:scale-105 mx-2 ${subTab === 'received' ? 'bg-blue-900 text-white' : 'bg-gray-300 text-black'}`}
            onClick={() => setSubTab('received')}
          >
            Received
          </button> */}
          {/* <button
            className={`py-2 px-6 rounded-lg hover:scale-105 mx-2 ${subTab === 'sent' ? 'bg-blue-900 text-white' : 'bg-gray-300 text-black'}`}
            onClick={() => setSubTab('sent')}
          >
            Sent
          </button> */}
        </div>
      </div>

      <div className="">
        <div className="table-container">
          <table className="table  table-hover">
            <thead className="table-header">
              <tr>
                <th>Sender Fax No</th>
                <th>Receiver Fax No</th>
                <th>Status</th>
                <th>Status Text</th>
                <th>Date/Time Received</th>
                <th>Message Pages</th>
                <th>Message Price</th>
                <th>Preview</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {loading ? null : (
                faxHistory.length > 0 ? (
                  faxHistory
                    .filter(row => row.status === "Received") // Filter by Received status
                    .map((row, index) => (
                      <tr 
                        key={index} 
                        className={row.read_status === "read" ? "text-light-gray" : "fw-bold"} // Apply bold style for unread rows
                      >
                        <td>{row.from}</td>
                        <td>{row.to}</td>
                        <td>{row.status}</td>
                        <td>{row.status_text}</td>
                        <td>{new Date(row.date_added * 1000).toLocaleString()}</td>
                        <td>{row.message_pages}</td>
                        <td>{row.message_price}</td>
                        <td>
                          <a
                            href={row._file_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default behavior
                              if (row.read_status === "unread") {
                                updatefaxstatus(row.message_id); // Call API to update status
                              }
                              window.open(row._file_url, "_blank"); // Open document in new tab
                            }}
                          >
                            View
                          </a>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="10">No fax history available</td>
                  </tr>
                )
                
              )}


            </tbody>
          </table>

          {loading ? null : (
            <div className="pagination-controls">
              <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => handlePageChange(page)}
                rowsPerPage={rowsPerPage}
                onLimitPerPage={handleRowsPerPageChange}
              />
            </div>
          )}

        </div>

        {/* <div >
        {subTab === 'received' && <Received faxHistory={faxHistory} loading={loading} />}
        </div>
        <div className="col">
        {subTab === 'sent' && <Sent faxHistory={faxHistory} loading={loading} />}
        </div> */}
      </div>
      {loading && <CommonSpinner />}
    </div>
  );
};

export default Faxes;
